<template>
  <div class="home__content home__recent scrollable-pagination">
    <loader-dots v-if="showLoader" />

    <div class="home__header">
      <h1 class="home__title">Недавно открытые</h1>
    </div>
    <nav class="home__list-nav">
      <div
        v-for="(label, key) in periodLabels"
        :key="key"
        class="home__list-nav-item"
        :class="{ _active: key === period }"
        @click="setPeriod(key)"
      >
        {{ label }}
      </div>
    </nav>
    <div class="home__list recent">
      <list-items-loadable
        v-slot="{ item }"
        :items="items"
        emptyText="Похоже в это время вы не просматривали документы"
      >
        <document-snippet-medium
          v-slot:before
          :document="item.document"
          :format="item.openingFormat"
        >
          <div class="recent__datetime">
            <div v-if="period !== periodToday" class="recent__date">
              {{ item.openingDate | formatDate }}
            </div>
            <div class="recent__time">{{ item.openingTime }}</div>
          </div>
        </document-snippet-medium>
      </list-items-loadable>
      <list-paginator
        :items-total="itemsTotal"
        :items-per-page="itemsPerPage"
        :items-per-page-options="[20, 50, 100]"
        items-per-page-label="Документов на странице:"
        @update="handlePaginatorUpdate"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import {
  RECENT_DOCUMENTS_PERIOD_ALL,
  RECENT_DOCUMENTS_PERIOD_TODAY,
  RECENT_DOCUMENTS_PERIOD_YESTERDAY,
  RECENT_DOCUMENTS_PERIOD_WEEK,
  RECENT_DOCUMENTS_PERIOD_PREV_WEEK
} from '@src/api/user';

import DocumentSnippetMedium from '@@/shared/snippets/Snippet_Medium';
import ListItemsLoadable from '@@/shared/list/ListItemsLoadable';
import ListPaginator from '@@/shared/list/ListPagination';
import LoaderDots from '@@/shared/loaders/LoaderDots';

const periodLabels = {
  [RECENT_DOCUMENTS_PERIOD_TODAY]: 'Сегодня',
  [RECENT_DOCUMENTS_PERIOD_YESTERDAY]: 'Вчера',
  [RECENT_DOCUMENTS_PERIOD_WEEK]: 'На этой неделе',
  [RECENT_DOCUMENTS_PERIOD_PREV_WEEK]: 'На прошлой неделе',
  [RECENT_DOCUMENTS_PERIOD_ALL]: 'Все'
};

export default {
  components: {
    DocumentSnippetMedium,
    ListItemsLoadable,
    ListPaginator,
    LoaderDots
  },

  data: () => ({
    period: RECENT_DOCUMENTS_PERIOD_TODAY,
    periodToday: RECENT_DOCUMENTS_PERIOD_TODAY,
    periodLabels: periodLabels,
    itemsPerPage: 20,
    itemsOffset: 0,
    itemsPromise: null
  }),

  computed: {
    ...mapGetters({
      items: 'recentDocuments',
      itemsTotal: 'recentDocumentsTotal',
      showLoader: 'showLoader'
    })
  },

  async created() {
    if( this.$route.query && this.$route.query.mode) {
      this.period = this.$route.query.mode;
    }
    await this.loadItems();
  },

  methods: {
    async loadItems() {
      await this.$store.dispatch('getRecentDocuments', {
        period: this.period,
        itemsLimit: this.itemsPerPage,
        itemsOffset: this.itemsOffset
      });
    },
    setPeriod(period) {
      // Это нужно для восстановления состояния страницы при принудитеьном 
      // обновлении из браузера 
      this.$router.push({
        name: 'recent',
        query: {
          mode: period
        }
      })

      this.period = period;
      this.loadItems();
    },
    handlePaginatorUpdate(obj) {
      if ('limit' in obj) this.itemsPerPage = obj.limit;
      if ('offset' in obj) this.itemsOffset = obj.offset;
      this.loadItems();
    }
  },

  metaInfo: {
    title: 'Недавно открытые'
  }
};
</script>
